module.exports = __webpack_public_path__ + "img/media_fed_1.b63d9a75.png";